var map = {
	"./common.de.json": "17b1",
	"./common.en.json": "8996",
	"./common.ru.json": "c936",
	"./contactBlock.de.json": "fee5",
	"./contactBlock.en.json": "e143",
	"./contactBlock.ru.json": "8d8c",
	"./de.json": "6ce2",
	"./demo.de.json": "50f6",
	"./demo.en.json": "9eed",
	"./demo.ru.json": "a40a",
	"./en.json": "edd4",
	"./event.de.json": "4d73",
	"./event.en.json": "a4e8",
	"./event.ru.json": "54ba",
	"./newShardList.de.json": "6718",
	"./newShardList.en.json": "02fb7",
	"./newShardList.ru.json": "f124",
	"./newstatistics.de.json": "a54d",
	"./newstatistics.en.json": "18c8",
	"./newstatistics.ru.json": "74fc",
	"./notification.de.json": "b1a4",
	"./notification.en.json": "d0ba",
	"./notification.ru.json": "1a71",
	"./products.de.json": "4e19",
	"./products.en.json": "985c",
	"./products.ru.json": "80a1",
	"./profile.de.json": "af35",
	"./profile.en.json": "0e5f",
	"./profile.ru.json": "6590",
	"./ru.json": "7704",
	"./shardList.de.json": "41a3",
	"./shardList.en.json": "1689",
	"./shardList.ru.json": "84b1",
	"./sidebar.de.json": "d786",
	"./sidebar.en.json": "85bc",
	"./sidebar.ru.json": "9aff",
	"./signin.de.json": "8545",
	"./signin.en.json": "97d1",
	"./signin.ru.json": "23cf",
	"./statistic.de.json": "9956",
	"./statistic.en.json": "8dfa",
	"./statistic.ru.json": "7332",
	"./support.de.json": "e4cf",
	"./support.en.json": "eb55",
	"./support.ru.json": "35f7",
	"./survey.de.json": "8aa8",
	"./survey.en.json": "ddbc",
	"./survey.ru.json": "0f9f",
	"./surveys.de.json": "d205",
	"./surveys.en.json": "cb08",
	"./surveys.ru.json": "7d3c",
	"./table.de.json": "54b0",
	"./table.en.json": "e6ae",
	"./table.ru.json": "5b05",
	"./test.de.json": "bcbf",
	"./test.en.json": "2f77",
	"./test.ru.json": "bf67",
	"./toolbar.de.json": "e577",
	"./toolbar.en.json": "8460",
	"./toolbar.ru.json": "4241",
	"./tooltip.de.json": "36f6",
	"./tooltip.en.json": "0bed",
	"./tooltip.ru.json": "ce35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f916";